import { constants, typographyStyles } from "@newsela/angelou";

const { heading4Obj, textMObj } = typographyStyles;
const { colors } = constants;

const yellow500 = colors.ui.yellow[500];

export const containerCss = {
  display: "grid",
  gridGap: "4px",
};

export const rootCss = {
  backgroundColor: yellow500,
  display: "flex",
  padding: "16px",
};

export const iconCss = {
  height: "auto",
  width: "40px",

  "path:first-of-type": {
    filter: "drop-shadow(2px -1px 0px rgb(29 29 29 / 0.25))",
  },

  "path:last-of-type": {
    stroke: yellow500,
  },
};

export const contentCss = {
  paddingLeft: "16px",
};

export const headingCss = {
  ...heading4Obj,
  margin: 0,
};

export const textCss = {
  ...textMObj,
  margin: "4px 0 0",
};
